import type { EntitySummary } from '@/types/dashboard';

interface EntitySelectorProps {
  entities: EntitySummary[];
  selectedEntity: EntitySummary | null;
  onSelect: (entity: EntitySummary) => void;
  isLoading: boolean;
}

export function EntitySelector({ entities, selectedEntity, onSelect, isLoading }: EntitySelectorProps) {
  if (isLoading) {
    return (
      <select className="form-select form-select-sm" disabled aria-label="Loading entities">
        <option>Загрузка...</option>
      </select>
    );
  }

  if (entities.length === 0) {
    return (
      <select className="form-select form-select-sm" disabled aria-label="No entities available">
        <option>Нет доступных сущностей</option>
      </select>
    );
  }

  return (
    <select
      className="form-select form-select-sm"
      value={selectedEntity?.uuid ?? ''}
      onChange={(e) => {
        const entity = entities.find(ent => ent.uuid === e.target.value);
        if (entity) onSelect(entity);
      }}
      aria-label="Select entity"
    >
      {!selectedEntity && <option value="">Выберите сущность</option>}
      {entities.map(entity => (
        <option key={entity.uuid} value={entity.uuid}>
          {entity.title}
        </option>
      ))}
    </select>
  );
}
